export const ACTIONS = {
  SET_ID: "SET_ID",
  SET_NOTE_TITLE: "SET_NOTE_TITLE",
  SET_NOTE_CONTENT: "SET_NOTE_CONTENT",
  CLEAR_INPUT: "CLEAR_INPUT",
};
